import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import usePusher from '@/hooks/usePusher.js';
import usePresenceId from '@/components/presenceHandler/usePresenceId.js';
import Avatar from './Avatar.jsx';

const PresenceHandler = () => {
  const presencesRef = useRef([]);
  const client = usePusher();
  const presenceId = usePresenceId();

  const members = useSelector((state) => state.presence.members);
  const mappedMembers = useMemo(() => Object.entries(members).map(([id, info]) => ({ id, ...info })), [members]);

  useEffect(() => {
    if (typeof client?.subscribe === 'undefined') {
      return;
    }

    if (presenceId && !presencesRef.current.includes(presenceId)) {
      presencesRef.current.push(presenceId);
      client.subscribeToPresence(`presence-${presenceId}`);
    }

    presencesRef.current = presencesRef.current.filter((id) => {
      if (id !== presenceId) {
        client.unsubscribe(`presence-${id}`);
        return false;
      }
      return true;
    });
  }, [presenceId, client]);

  if (mappedMembers?.length <= 1 || !presenceId) {
    return null;
  }

  return (
    <div className="presence-container">
      {mappedMembers.slice(0, 5).map((member, index) => (
        <Avatar //
          key={member.id}
          className={member.isCurrentUser ? 'animated current-user' : 'animated'}
          id={member.id}
          name={member.name}
          email={member.email}
          isCurrent={member.isCurrentUser}
          zIndex={mappedMembers.length + index}
        />
      ))}
      {mappedMembers.length > 5 && (
        <Avatar //
          overrideBackgroundColor="lightgrey"
          overrideContent={`+${mappedMembers.length - 5}`}
          title={`+ ${mappedMembers.length - 5} other users`}
          zIndex={10}
        />
      )}
    </div>
  );
};

export default PresenceHandler;
